"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirestoreFieldValue = exports.Firebase = exports.FirebaseApp = void 0;

var app_1 = __importDefault(require("firebase/app"));

require("firebase/firestore");

require("firebase/auth");

var development_1 = __importDefault(require("./config/development"));

var production_1 = __importDefault(require("./config/production"));

var staging_1 = __importDefault(require("./config/staging"));

var lodash_1 = __importDefault(require("lodash"));

var env = process.env.REACT_APP_ENV || 'development';
var configs = {
  production: production_1.default,
  development: development_1.default,
  staging: staging_1.default
};
var config = lodash_1.default.get(configs, env) || development_1.default;
exports.FirebaseApp = app_1.default.initializeApp(config);
exports.Firebase = app_1.default;
exports.FirestoreFieldValue = app_1.default.firestore.FieldValue;